import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import GraphQL from '~/types/graphql';

import InternalLink, {
	InternalLinkStyle,
} from '~/components/patterns/links/InternalLink';

import useIsAllowedWithAccount from '~/hooks/useIsAllowedWithAccount';



const messages = defineMessages({
	notSolvable: {
		id: 'ui.formErrors.emailDomainNotWhitelisted.notSolvable',
	},
	solvable: {
		id: 'ui.formErrors.emailDomainNotWhitelisted.solvable',
	},
});



const EmailDomainNotWhitelistedErrorMessage = (props) => {
	const {
		accountId,
	} = props;

	const isSolvable = useIsAllowedWithAccount(
		accountId,
		GraphQL.ActionWithAccount.ManageOrganizationAccessControl,
	);

	if (isSolvable.yes) {
		return (
			<FormattedMessage
				{...messages.solvable}
				values={{
					a: (chunks) => (
						<InternalLink
							routeName="account.settings.organizationAccess"
							routeParams={{
								accountId,
							}}
							style={InternalLinkStyle.Decent}
						>
							{chunks}
						</InternalLink>
					),
				}}
			/>
		);
	}

	return (
		<FormattedMessage {...messages.notSolvable} />
	);
};



export default React.memo(EmailDomainNotWhitelistedErrorMessage);
